/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagesortlabel3Inputs */

const en_ticketpagesortlabel3 = /** @type {(inputs: Ticketpagesortlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort`)
};

const de_ticketpagesortlabel3 = /** @type {(inputs: Ticketpagesortlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren`)
};

/**
* | output |
* | --- |
* | "Sort" |
*
* @param {Ticketpagesortlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesortlabel3 = /** @type {((inputs?: Ticketpagesortlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesortlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesortlabel3(inputs)
	return de_ticketpagesortlabel3(inputs)
});
export { ticketpagesortlabel3 as "ticketPageSortLabel" }